const branch = (ComponentOnPass, ComponentOnFail) =>
  function branch({ test, ...props }) {
    return test ? (
      <ComponentOnPass {...props} />
    ) : ComponentOnFail ? (
      <ComponentOnFail {...props} />
    ) : null;
  };

export default branch;
